import {Component, Input} from '@angular/core';
import {SelectType} from '../../../../../../../../../ui/select/select.component';
import {UntypedFormGroup} from '@angular/forms';
import {RodzajPowierzchni} from '../../../../../../../../../../services/slownik/types/rodzaj-powierzchni';

@Component({
  selector: 'shared-rodzaj-powierzchni',
  templateUrl: './rodzaj-powierzchni.component.html'
})

export class RodzajPowierzchniComponent {

  @Input()
  formularz!: UntypedFormGroup;

  @Input()
  rodzajePowierzchni: RodzajPowierzchni[] = [];

  konwertujRodzajePowierzchni(rodzajePowierzchni: RodzajPowierzchni[]): SelectType[] {
    return rodzajePowierzchni.map(rodzaj => ({kod: rodzaj.nazwa, opis: rodzaj.opis} as SelectType));
  }
}


